"use client";

import {datadogRum} from "@datadog/browser-rum";
import {useUserInfo} from "./contexts/userInfoContext";
import {useCampusContext} from "./contexts/CampusCookieContext";
import {USER_ROLE_MAP} from "@/shared/UserRole";

datadogRum.init({
	// These "secrets" are given to the client, so I don't care that they're git committed
	applicationId: "bb113741-9278-4b42-9e3a-b4343b7d6410",
	clientToken: "pub36b9011c595d21238f41a05c59ec4d69",
	site: "us3.datadoghq.com",
	service: "academy2-nextjs",
	env: process.env.NEXT_PUBLIC_ENVIRONMENT_STRING,
	version: process.env.NEXT_PUBLIC_BUILD_VERSION,
	sessionSampleRate: 100,
	sessionReplaySampleRate: 100,
	trackUserInteractions: true,
	trackResources: true,
	trackLongTasks: true,
	defaultPrivacyLevel: "mask-user-input",
	// Specify URLs to propagate trace headers for connection between RUM and backend trace
	allowedTracingUrls: [
		process.env.NEXT_PUBLIC_NEXT_SITE_URL ?? "",
		// Add these if we set up datadog APM on the other services
		// process.env.NEXT_PUBLIC_STRAPI_API_URL ?? "",
		// process.env.NEXT_PUBLIC_AOPS_BASE_URL ?? "",
		// process.env.NEXT_PUBLIC_LEGACY_SITE_URL ?? "",
	],
});

export default function DatadogInit() {
	const {userInfo} = useUserInfo();
	const {campus} = useCampusContext();

	// Set basic information about the user to help debug
	datadogRum.setUser({
		id: userInfo?.platform_user_id ?? "",
		cookie_campus: campus?.campusId,
		is_staff: userInfo?.roles.includes(USER_ROLE_MAP.OFFICE_STAFF)
			? true
			: false,
	});

	// Render nothing - this component is only included so that the init code
	// above will run client-side
	return null;
}
